/**
 * Every player-visible sentence, templated over the IP object so a rename
 * in ip.ts retroactively fixes all of them. Saves and events store lexicon
 * KEYS, never display strings.
 */
import { IP } from './ip';

export const LEX = {
  awayTitle: (): string => 'WHILE YOU WERE AWAY…',
  awayBorn: (n: number): string =>
    `${n} NEW ${n === 1 ? IP.CREATURE.toUpperCase() : IP.CREATURES.toUpperCase()} ${n === 1 ? 'WAS' : 'WERE'} BORN.`,
  awayDormant: (n: number): string =>
    n === 1 ? '1 CURLED UP TO SLEEP. IT IS WAITING.' : `${n} CURLED UP TO SLEEP. THEY ARE WAITING.`,
  awayPop: (n: number): string => `${IP.COLLECTIVE.toUpperCase()} IS ${n}.`,
  awayQuiet: (): string => 'ALL QUIET. THEY ARE GLAD YOU ARE BACK.',
  awayHours: (h: number): string =>
    h >= 48 ? `${Math.round(h / 24)} DAYS PASSED.` : `${Math.max(1, Math.round(h))} HOURS PASSED.`,
  okButton: (): string => 'OK',
  built: (itemType: number): string => {
    const name = itemType === 5 ? 'A FEEDER TREE' : itemType === 6 ? 'A BATH SPRING' : 'A PLAY TOTEM';
    return `THEY BUILT ${name}. BY THEMSELVES.`;
  },
  updateReady: (): string => `${IP.STUDIO.toUpperCase()} PATCH READY`,
  updateAction: (): string => 'INSTALL',
  signalLost: (): string => 'SIGNAL LOST',
  signalWaiting: (): string => 'RECONNECTING…',
  observed: (name: string): string => `OBSERVED: ${name}`,
  toolHint: (tool: string): string => {
    switch (tool) {
      case 'hand':
        return 'HAND: TAP = PET. RUB = LONG PET. GRASS TAP = CALL, TWICE = DANCE. HOLD = INSPECT.';
      case 'apple':
        return 'FOOD: TAP THE GROUND TO DROP AN APPLE.';
      case 'sponge':
        return 'SPONGE: SCRUB THE POOPS AWAY — GRUBBY FRIENDS PLOP MORE. IT WAKES SLEEPERS TOO.';
      default:
        return 'BALL: DRAG AND RELEASE TO THROW IT.';
    }
  },
  resetTitle: (): string => 'NEW WORLD?',
  resetLines: (): string[] => ['THIS MEADOW WILL BE FORGOTTEN.', 'THEY WILL NOT REMEMBER YOU.'],
  resetYes: (): string => 'NEW WORLD',
  resetNo: (): string => 'STAY',
  installAsk: (): string => 'KEEP US WITH YOU?',
  installAction: (): string => 'INSTALL',
  installIosHint: (): string => 'ADD US: SHARE → ADD TO HOME SCREEN',
  profileTitle: (): string => 'FILE ON YOU',
  logbookTitle: (): string => 'OBSERVATIONS',
} as const;

// The Song's speech and questions are assembled generatively — see
// src/app/conlang.ts (its invented words) and src/app/grammar.ts (frames).
